
import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Select } from '@amzn/stencil-react-components/select';
import { InputWrapper } from '@amzn/stencil-react-components/input';

import { Col, Row, Spacer } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import cloneDeep from 'lodash/cloneDeep';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { updateActiveFilters, updateManagerFilter } from '../../../actions/ruleFiltersActions';
import { ManagerOption, MANAGER_INFO, SegmentFilters } from '../../../constants/createSegment';
import {
  activeRuleFiltersSelector,
  ruleFilterManagerStatusSelector,
} from '../../../selectors/selectors';

import { IconInformationSmall } from '@amzn/stencil-react-icons';


const IconWithTooltip = withTooltip()(IconInformationSmall);
const ManagerFilter = () => {
  const isManager = useSelector(ruleFilterManagerStatusSelector);
  const activeFilters = useSelector(activeRuleFiltersSelector);

  const [isDisabled, setIsDisabled] = useState(
    !activeFilters?.includes(SegmentFilters.MANAGER_STATUS_FILTER),
  );
  const dispatch = useDispatch();

  const onManagerStatusChange = e => {
    dispatch(updateManagerFilter(e));
  };

  const onFilterChange = e => {
    setIsDisabled(!e?.target?.checked);
    let managerFilter = cloneDeep(activeFilters);
    managerFilter = managerFilter.filter(f => f !== SegmentFilters.MANAGER_STATUS_FILTER);
    if (e.target.checked) {
      managerFilter.push(SegmentFilters.MANAGER_STATUS_FILTER);
      dispatch(updateActiveFilters(managerFilter));
    } else {
      dispatch(updateManagerFilter(''));
      dispatch(updateActiveFilters(managerFilter));
    }
  };
  return (
    <>
      <Row gridGap="S100">
        <Checkbox
          data-testid="rule-filter-4"
          checked={!isDisabled}
          onChange={e => onFilterChange(e)}
        />
        <Label display="flex" fontSize={'T300'} htmlFor="rule-filter-4" id="rule-filter-label4">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage
              id="app.ruleFilter.label.managerStatus"
              defaultMessage="Manager Status"
            />
          </Text>

          <Spacer width="10px" />
          <IconWithTooltip title="Country" tooltipText={MANAGER_INFO} color="primary70" />
        </Label>
      </Row>
      <Row>
        <Col width={'60%'}>
          <InputWrapper id="isManager">
            {inputProps => (
              <Select
                disabled={isDisabled}
                data-testid="manager-dropdown"
                options={[ManagerOption.IS_MANAGER, ManagerOption.NOT_MANAGER]}
                {...inputProps}
                value={isManager}
                onChange={e => {
                  onManagerStatusChange(e);
                }}
              />
            )}
          </InputWrapper>
        </Col>
      </Row>
    </>
  );
};

export default ManagerFilter;
